module.exports = __webpack_public_path__ + "platform/static/media/whatsapp.8879b811.svg";